module.exports = __webpack_public_path__ + "img/luxury_phone@2x.e6d4223a.png";